/* LGC Price Convert — converts DKK amounts written in page content to the active market currency.
 *
 * Single amounts in page content:
 *   <span class="lgc-price" data-dkk="500">500 kr</span>
 *
 * Whole price tables: every cell that only contains a number is converted, except the first column
 * (tier level). In text cells, amounts written as "13,50 kr" or "1000 DKK" are converted.
 * Applies to tables inside [data-lgc-price-tables] and to <table class="lgc-price-table">.
 *
 * Bare numbers next to a theme currency suffix (rounded, no currency symbol added):
 *   <span data-lgc-dkk-number="6400">6400</span> KR
 * Scripts can use window.lgcConvertDkk(6400) for the same conversion.
 *
 * The original text is kept when the visitor is on DKK or the rate is unavailable.
 */
(function () {
  "use strict";

  // Danish number format as typed in page content: "480", "1660", "1.660", "11,25"
  const DANISH_NUMBER = /^(\d{1,3}(\.\d{3})+|\d+)(,\d+)?$/;
  // A number followed by "kr", "kr." or "DKK" inside running text
  const AMOUNT_IN_TEXT = /((?:\d{1,3}(?:\.\d{3})+|\d+)(?:,\d+)?)[\s ]*(?:kr\.?|DKK)(?![a-zæøåäö])/gi;

  function parseDanishNumber(text) {
    const value = String(text).replace(/[\s ]/g, "");
    if (!DANISH_NUMBER.test(value)) return NaN;
    return parseFloat(value.replace(/\./g, "").replace(",", "."));
  }

  function getActiveRate() {
    const currency = window.Shopify?.currency;
    const rate = parseFloat(currency?.rate);

    if (!currency?.active || Number.isNaN(rate) || rate <= 0) return null;
    if (currency.active === "DKK" && rate === 1) return null;
    return rate;
  }

  // Whole-number amount in the active currency, or the input unchanged when no conversion applies
  window.lgcConvertDkk = function (amountDkk) {
    const rate = getActiveRate();
    const value = parseDanishNumber(amountDkk);
    if (rate === null || Number.isNaN(value)) return amountDkk;
    return Math.round(value * rate);
  };

  function convertPrices() {
    const rate = getActiveRate();
    if (rate === null) return;

    const activeCurrency = window.Shopify.currency.active;

    const locale = document.documentElement.lang || "da";

    function formatAmount(amountDkk) {
      const converted = Math.round(amountDkk * rate * 100) / 100;
      const isWhole = Number.isInteger(converted);

      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency: activeCurrency,
          minimumFractionDigits: isWhole ? 0 : 2,
          maximumFractionDigits: isWhole ? 0 : 2,
        }).format(converted);
      } catch (e) {
        return converted + " " + activeCurrency;
      }
    }

    document.querySelectorAll(".lgc-price[data-dkk]").forEach(function (el) {
      const amountDkk = parseDanishNumber(el.dataset.dkk);
      if (Number.isNaN(amountDkk)) return;

      el.textContent = formatAmount(amountDkk);
      el.dataset.lgcConverted = "true";
    });

    document.querySelectorAll("[data-lgc-dkk-number]").forEach(function (el) {
      if (el.dataset.lgcConverted) return;
      el.textContent = window.lgcConvertDkk(el.dataset.lgcDkkNumber);
      el.dataset.lgcConverted = "true";
    });

    document.querySelectorAll("[data-lgc-price-tables] table, table.lgc-price-table").forEach(function (table) {
      table.querySelectorAll("tr").forEach(function (row) {
        Array.from(row.cells).forEach(function (cell, index) {
          if (index === 0 || cell.dataset.lgcConverted) return;

          const amountDkk = parseDanishNumber(cell.textContent);

          if (!Number.isNaN(amountDkk)) {
            // Write into the innermost element so the cell keeps its formatting
            let target = cell;
            while (target.children.length === 1) target = target.children[0];
            target.textContent = formatAmount(amountDkk);
          } else {
            // Amounts inside text, e.g. "13,50 kr / pr. 1000 kr i dækning (1,35%)" — percentages are left as is
            const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
            const textNodes = [];
            while (walker.nextNode()) textNodes.push(walker.currentNode);
            textNodes.forEach(function (node) {
              node.textContent = node.textContent.replace(AMOUNT_IN_TEXT, function (match, number) {
                const value = parseDanishNumber(number);
                return Number.isNaN(value) ? match : formatAmount(value);
              });
            });
          }
          cell.dataset.lgcConverted = "true";
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", convertPrices);
  } else {
    convertPrices();
  }
})();
